var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlika1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1715",
    "data-name": "Group 1715",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272.593,
    height: 211.256,
    viewBox: "0 0 272.593 211.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2744",
    "data-name": "Rectangle 2744",
    width: 272.593,
    height: 211.256,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1682",
    "data-name": "Group 1682",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M1,138.822l3.461,23.611a60.051,60.051,0,0,0,96.861,35.415l30.082-24.425,14.839,45.386,90.833,3.146,32.3-78.506a35.092,35.092,0,0,0-28.4-48.2l-57.855-6.758L137.7,97.031l-74.2,64.26L39.672,135.228Z",
    transform: "translate(-0.225 -19.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M236.852,222.507h-.026l-90.833-3.146a.777.777,0,0,1-.711-.534l-14.488-44.315-29.205,23.714A60.826,60.826,0,0,1,3.475,162.353L.008,138.71a.777.777,0,0,1,.7-.885l38.672-3.595a.774.774,0,0,1,.644.249l23.323,25.506,73.624-63.765a.773.773,0,0,1,.365-.175l45.417-8.538a.76.76,0,0,1,.233-.009l57.854,6.758a35.867,35.867,0,0,1,29.029,49.264l-32.3,78.506a.776.776,0,0,1-.717.481m-90.264-4.678,89.752,3.108,32.091-78.007A34.316,34.316,0,0,0,240.656,95.8l-57.737-6.744-45.1,8.478L63.788,161.652a.776.776,0,0,1-1.08-.063L39.135,135.81,1.662,139.294,5,162.1a59.276,59.276,0,0,0,95.6,34.926L130.69,172.6a.777.777,0,0,1,1.227.361Z",
    transform: "translate(0 -19.636)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M147.854,79.574a14.629,14.629,0,0,0-8.551,9.248,3.08,3.08,0,0,1-1.709,1.9l-.055.024a3.262,3.262,0,0,1-4.3-1.674L125.635,71.69,81.572,90.941A13.527,13.527,0,0,0,74.59,108.76l19.263,44.034,18.406-8.041a3.246,3.246,0,0,0,.753-3.659l0,0a3.242,3.242,0,0,0-1.993-1.789,14.629,14.629,0,0,1-9.193-8.525A14.692,14.692,0,0,1,128.93,119.44a14.616,14.616,0,0,1-.1,11.948,3.532,3.532,0,0,0-.268,2.414,3.247,3.247,0,0,0,3.354,2.362l18.4-8.041-7.541-17.238a3.384,3.384,0,0,1,.7-3.835,3.254,3.254,0,0,1,3.624-.545,14.677,14.677,0,0,0,19.362-19.827,14.808,14.808,0,0,0-18.618-7.1",
    transform: "translate(-16.485 -16.09)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3083",
    "data-name": "Path 3083",
    d: "M92.494,82.029a4.515,4.515,0,0,0,1.324-3.3,4.769,4.769,0,0,0-1.414-3.3L62.763,45.8a.9.9,0,0,0-.119-.078s0-.009-.008-.012a20.73,20.73,0,0,0-29.3,0l-9.674,9.669A77.749,77.749,0,0,0,.712,110.739v18.8a.98.98,0,0,0,.98.98.965.965,0,0,0,.419-.1c1.005,1,5.86,5.144,17.42,5.144,6.08,0,14.014-1.15,24.207-4.513a1.013,1.013,0,0,0,.645-1.28.465.465,0,0,1,.017-.662V109.992a.952.952,0,0,0-.189-.548,22.272,22.272,0,0,0,7.617-4.985l4.136-4.208.2-.645a72.912,72.912,0,0,1,.2-8.819c2.473-1.349,5.213-6.319,4.935-8.4l13.53,13.52a9.9,9.9,0,0,0,14,0,4.738,4.738,0,0,0,0-6.695l-4.583-4.58a9.931,9.931,0,0,0,1.564.136,9.418,9.418,0,0,0,6.695-2.743",
    transform: "translate(-0.16 -8.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3084",
    "data-name": "Path 3084",
    d: "M255.408,71.373l3.719,13.373,6.312,3.461-8.226,14.583a12.088,12.088,0,0,1-22.033-2.234l-3.108-9.665Z",
    transform: "translate(-52.085 -16.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3085",
    "data-name": "Path 3085",
    d: "M246.522,109.492a13.444,13.444,0,0,1-1.361-.069,12.7,12.7,0,0,1-10.944-8.854L231.109,90.9a.776.776,0,0,1,.24-.833l23.337-19.518a.775.775,0,0,1,1.245.387L259.563,84l6.025,3.3a.776.776,0,0,1,.3,1.062l-8.226,14.583a12.674,12.674,0,0,1-11.142,6.544M232.746,90.926l2.949,9.167a11.312,11.312,0,0,0,20.618,2.092l7.841-13.9L258.53,85.2a.774.774,0,0,1-.374-.472l-3.4-12.214Z",
    transform: "translate(-51.861 -15.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3086",
    "data-name": "Path 3086",
    d: "M235.18,100.9a12.654,12.654,0,0,0,.72,1.775,19.036,19.036,0,0,0,5.809-6.406l12.963-22.978-.691-.379-21.91,18.324Z",
    transform: "translate(-52.085 -16.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3087",
    "data-name": "Path 3087",
    d: "M243.182,7.176c-9.7-5.007-22.449-2.639-24.492,1.144a13.83,13.83,0,0,0-7.339-3.759c-6.888-1.243-13.389,2.542-14.52,8.456-.979,5.123,2.395,10.156,7.791,12.221a51.407,51.407,0,0,0-3.56,11.364c-3.105,16.228,23.065,22.294,28.031,23.191,13.434,2.425,26.6-7.49,29.4-22.147s-3.6-24.423-15.311-30.47",
    transform: "translate(-44.138 -0.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    "data-name": "Path 3088",
    d: "M253.4,13.294c-3.819.719-6.93,2.355-8.812,4.923-5.311,7.245-.468,24.416,14.128,27.49.91.192,1.924-.078,2.747.321,2.507-13.286-.871-25.613-8.063-32.733",
    transform: "translate(-54.425 -2.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    d: "M206.186,24.472c5.507,2.912,13.007,4.6,21.233,4.39,13.835-.361,25.339-6,28.646-13.345C252.281,8.294,246.317,3.274,238.9,2.022c-12.676-2.139-25.739,7.384-32.713,22.449",
    transform: "translate(-46.276 -0.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M250.534,46.259a10.146,10.146,0,0,0-5.7,1.926,20.963,20.963,0,0,1-10.922-13.453,51.818,51.818,0,0,1-7.642.762c-8.061.21-15.421-1.413-20.894-4.218a52.734,52.734,0,0,0-3.4,11.237c-3.663,19.7,4.051,37.647,17.229,40.1,9.871,1.833,20.009-5.553,26.014-17.653a10.186,10.186,0,1,0,5.319-18.7",
    transform: "translate(-45.125 -7.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M221.99,83.436a17.248,17.248,0,0,1-3.156-.29c-6.637-1.232-12.141-6.218-15.5-14.036-3.314-7.711-4.148-17.288-2.349-26.963a53.555,53.555,0,0,1,3.454-11.4.776.776,0,0,1,1.066-.383c5.593,2.865,12.893,4.335,20.52,4.134a51.091,51.091,0,0,0,7.529-.752.773.773,0,0,1,.883.562,20.111,20.111,0,0,0,10.109,12.758,10.962,10.962,0,1,1,.761,18.763c-5.711,11.023-14.549,17.61-23.315,17.611M205.544,32.112a52.134,52.134,0,0,0-3.035,10.319c-1.743,9.377-.945,18.634,2.25,26.067,3.148,7.328,8.247,11.987,14.358,13.123,9.249,1.713,19.129-5.048,25.177-17.235a.776.776,0,0,1,1.121-.3,9.41,9.41,0,1,0,5.163-17.275c-.084,0-.166,0-.25,0a9.364,9.364,0,0,0-5.265,1.778.773.773,0,0,1-.79.071,21.555,21.555,0,0,1-11.14-13.271,52.852,52.852,0,0,1-7.068.658,45.6,45.6,0,0,1-20.52-3.934m44.764,13.923h0Z",
    transform: "translate(-44.9 -6.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3092",
    "data-name": "Path 3092",
    d: "M219.888,7.7a.776.776,0,0,1-.685-.41c-4.793-8.962-16.73-4.778-16.848-4.736a.776.776,0,1,1-.527-1.46c.133-.047,13.324-4.668,18.743,5.464a.775.775,0,0,1-.683,1.142",
    transform: "translate(-45.182 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    "data-name": "Path 3093",
    d: "M203.5,55.111c.3,1.545,1.335,2.645,2.319,2.455s1.54-1.594,1.243-3.139-1.335-2.645-2.318-2.456-1.541,1.595-1.244,3.139",
    transform: "translate(-45.656 -11.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    "data-name": "Path 3094",
    d: "M199.839,48.636a.776.776,0,0,1-.33-1.478,13.38,13.38,0,0,1,6.827-1.021.776.776,0,0,1-.216,1.536,12.005,12.005,0,0,0-5.952.889.768.768,0,0,1-.329.074",
    transform: "translate(-44.677 -10.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    d: "M223,55.16c.3,1.545,1.335,2.645,2.319,2.455s1.54-1.594,1.244-3.139-1.336-2.645-2.319-2.456S222.7,53.615,223,55.16",
    transform: "translate(-50.032 -11.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    d: "M230.309,49.96a.776.776,0,0,1-.514-.195c-.043-.037-4.232-3.686-8.63-2.348a.776.776,0,0,1-.451-1.484c5.241-1.592,9.917,2.5,10.113,2.672a.776.776,0,0,1-.517,1.355",
    transform: "translate(-49.412 -10.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M213.722,64.109c-.707,0-3.264-.1-4.293-1.491a2.381,2.381,0,0,1-.27-2.279c.748-2.237,2.04-9.456,2.054-9.529a.775.775,0,1,1,1.526.273c-.054.3-1.325,7.4-2.109,9.748a.865.865,0,0,0,.046.864c.517.7,2.343.88,3.158.861a.794.794,0,0,1,.8.755.776.776,0,0,1-.755.8l-.153,0",
    transform: "translate(-46.906 -11.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M215.834,75.627a7.564,7.564,0,0,1-1.7-.171.775.775,0,0,1,.392-1.5c.287.071,6.789,1.612,9.55-7.27a.776.776,0,1,1,1.481.46c-2.3,7.42-7.143,8.482-9.721,8.482",
    transform: "translate(-47.929 -14.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    d: "M259.258,60.56a.775.775,0,0,1-.64-1.212c.115-.169,2.889-4.142,7.448-3.551a.776.776,0,0,1-.2,1.539c-3.613-.476-5.945,2.854-5.968,2.888a.776.776,0,0,1-.641.336",
    transform: "translate(-58.013 -12.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M208.728,238.448a14.638,14.638,0,0,0,11.541-5.05,3.082,3.082,0,0,1,2.33-1.06h.06a3.26,3.26,0,0,1,3.267,3.255v18.974h48.09a13.536,13.536,0,0,0,13.541-13.531V192.977h-61.63v18.974a3.257,3.257,0,0,1-3.257,3.256,3.294,3.294,0,0,1-2.465-1.135,14.682,14.682,0,0,0-25.687,10.417,14.8,14.8,0,0,0,14.212,13.96",
    transform: "translate(-43.653 -43.311)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    "data-name": "Path 3101",
    d: "M280.523,192.079a14.621,14.621,0,0,0-5.006-11.491,3.238,3.238,0,0,1-1.11-2.437v0a3.256,3.256,0,0,1,3.257-3.255h18.988V126.834A13.537,13.537,0,0,0,283.111,113.3h-48.09v61.589h18.986a3.25,3.25,0,0,1,2.122,5.719,14.67,14.67,0,0,0,10.424,25.67,14.8,14.8,0,0,0,13.97-14.2",
    transform: "translate(-52.747 -25.429)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M171.684,166.7a14.622,14.622,0,0,0,5.054,11.533,3.079,3.079,0,0,1,1.061,2.328v.06a3.259,3.259,0,0,1-3.257,3.265H155.555v48.058A13.536,13.536,0,0,0,169.1,245.479h48.09V183.889H198.2a3.25,3.25,0,0,1-2.121-5.719,14.67,14.67,0,0,0-10.424-25.67,14.8,14.8,0,0,0-13.969,14.2",
    transform: "translate(-34.912 -34.223)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M306.372,204.512l.225,16.851s17.1-1.886,21.216-18.306,5.4-42.459-8.046-47.682-32.955-19.167-32.281-8.607c.5,7.912,23.607,21.569,23.607,21.569l-34.175-.449s-2.2,6.265-.7,11.544c3.841,13.523,4.131,7.414,4.806,9.1,2.407,6.012,7.7,12.93,25.35,15.98",
    transform: "translate(-61.875 -32.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    "data-name": "Path 3104",
    d: "M309.685,222.344a.776.776,0,0,1-.259-1.507c8.33-2.946,18.695-8.51,20.774-18.28,2.514-11.816,6.8-40.032-7.617-46.818L294.57,143.151a2.176,2.176,0,0,0-2.989,1.4,8.54,8.54,0,0,0,3.336,9.289l20.666,14.422a.776.776,0,1,1-.887,1.273l-20.667-14.422a10.1,10.1,0,0,1-3.943-10.979,3.729,3.729,0,0,1,5.12-2.4l28.026,12.593c15.438,7.264,11.077,36.373,8.486,48.551-2.229,10.474-13.071,16.342-21.774,19.419a.778.778,0,0,1-.259.045",
    transform: "translate(-65.023 -31.737)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M277.633,185.28a.773.773,0,0,1-.4-.115c-4.55-2.79-3-8.424-1.542-11.013a.772.772,0,0,1,.714-.395l44.061,2.122a.776.776,0,1,1-.074,1.55l-43.561-2.1c-.694,1.446-2.579,6.184,1.215,8.512a.776.776,0,0,1-.406,1.437",
    transform: "translate(-61.541 -38.997)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M317.391,205.436a.781.781,0,0,1-.126-.01c-1.32-.217-32.395-5.326-37.243-6.912-5.33-1.742-5.269-10.294-5.264-10.658a.778.778,0,0,1,.258-.567.769.769,0,0,1,.593-.194l44.812,4.352a.776.776,0,1,1-.15,1.545l-43.934-4.267c.123,2.053.769,7.2,4.166,8.315,4.737,1.548,36.69,6.8,37.013,6.854a.776.776,0,0,1-.125,1.542",
    transform: "translate(-61.665 -41.99)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M314.667,218.657c-.026,0-.053,0-.081,0-1.325-.139-32.461-3.551-33.189-17.594a.776.776,0,1,1,1.55-.08c.66,12.727,31.489,16.1,31.8,16.129a.776.776,0,0,1-.08,1.548",
    transform: "translate(-63.155 -44.942)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M103.271,86.471a10.027,10.027,0,0,1-7.088-2.956A.98.98,0,0,1,97.57,82.13a7.8,7.8,0,0,0,11.009.213,2.57,2.57,0,0,0,.75-1.881,2.826,2.826,0,0,0-.84-1.953l-29.64-29.62A.98.98,0,0,1,80.235,47.5l29.64,29.62a4.771,4.771,0,0,1,1.414,3.3,4.508,4.508,0,0,1-1.324,3.3,9.415,9.415,0,0,1-6.694,2.743",
    transform: "translate(-17.632 -10.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M93.4,102.189a9.832,9.832,0,0,1-7-2.9L52.589,65.5a.98.98,0,1,1,1.386-1.386L87.787,97.907a7.949,7.949,0,0,0,11.222,0,2.777,2.777,0,0,0,0-3.924l-37.623-37.6A.98.98,0,0,1,62.773,55L100.4,92.6a4.739,4.739,0,0,1,0,6.7,9.833,9.833,0,0,1-7,2.9",
    transform: "translate(-11.738 -12.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M63.582,98.534a9.072,9.072,0,0,1-5.375-1.745.98.98,0,1,1,1.16-1.581,7.166,7.166,0,0,0,9.3-10.847L51.532,67.236a.98.98,0,0,1,1.387-1.385L70.056,82.976a9.107,9.107,0,0,1-6.474,15.558",
    transform: "translate(-11.501 -14.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    "data-name": "Path 3111",
    d: "M38.412,102.445a.976.976,0,0,1-.693-.287l-9.725-9.719a.98.98,0,0,1,1.386-1.385l9.726,9.719a.98.98,0,0,1-.693,1.672",
    transform: "translate(-6.218 -20.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M42.693,110.236a10.824,10.824,0,0,1-7.7-3.188L28.74,100.8a.981.981,0,0,1-.2-1.085,9.839,9.839,0,0,1,5.838-5.108.979.979,0,1,1,.553,1.878,7.782,7.782,0,0,0-4.283,3.446l5.735,5.729A8.929,8.929,0,0,0,49.009,93.039L37.433,81.472a.98.98,0,1,1,1.387-1.386L50.4,91.654a10.885,10.885,0,0,1-7.7,18.582",
    transform: "translate(-6.386 -17.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M41.511,127.635a22.357,22.357,0,0,1-15.852-6.551.98.98,0,1,1,1.387-1.386,20.49,20.49,0,0,0,28.931,0l5.694-5.691a.98.98,0,1,1,1.387,1.385l-5.694,5.692a22.357,22.357,0,0,1-15.853,6.551",
    transform: "translate(-5.694 -25.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M1.691,130.519a.98.98,0,0,1-.98-.98v-18.8A77.752,77.752,0,0,1,23.656,55.382l9.674-9.668a20.73,20.73,0,0,1,29.3,0A.98.98,0,0,1,61.249,47.1a18.793,18.793,0,0,0-26.532,0l-9.674,9.669a75.8,75.8,0,0,0-22.37,53.971v18.8a.98.98,0,0,1-.981.98",
    transform: "translate(-0.16 -8.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M55.5,150.158a.98.98,0,0,1-.98-.98V130.065a.98.98,0,0,1,1.961,0v19.113a.98.98,0,0,1-.98.98",
    transform: "translate(-12.235 -28.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M19.855,161.117c-12.6,0-17.153-4.969-17.424-5.279A.775.775,0,0,1,3.6,154.815c.1.11,9.653,10.307,39.923.321a.776.776,0,0,1,.486,1.474c-10.185,3.36-18.1,4.508-24.151,4.508",
    transform: "translate(-0.503 -34.687)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M91.71,196.39a.775.775,0,0,1-.617-.3L80.752,182.6a.776.776,0,0,1,1.232-.945l10.342,13.482a.775.775,0,0,1-.144,1.087.765.765,0,0,1-.471.161",
    transform: "translate(-18.088 -40.703)",
    fill: "#080717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlika1);
export default __webpack_public_path__ + "static/media/slika1.5865ad5956a92d9ba78f309af0146370.svg";
export { ForwardRef as ReactComponent };